<div class="grid grid-cols-1 gap-4 md:grid-cols-2">
  <app-metric-tile
    [label]="'project.steps.providerResults.rfpIndividual.totalResult' | transloco"
    [value]="total().percentage | appNumber: '1.0-0'"
    suffix=" %"
    size="xl"
    testId="rfp-individual-total"
  >
    <app-score-bar [percentage]="total().percentage" />
    <span class="text-muted-color text-xs">
      {{ total().value | appNumber: '1.2-2' }} / {{ total().maxValue | appNumber: '1.2-2' }}
    </span>
  </app-metric-tile>
  <app-metric-tile
    [label]="'project.steps.providerResults.rfpIndividual.rank' | transloco"
    [value]="'project.steps.providerResults.rfpIndividual.rankValue' | transloco: rankParams()"
    size="xl"
    testId="rfp-individual-rank"
  />
</div>
